import React from 'react';
export function ClaimCreatedDealerTemplate() {
  return <div style={{
    fontFamily: 'Arial, sans-serif',
    maxWidth: '600px',
    margin: '0 auto'
  }} data-id="element-212">
      {/* Header with logo */}
      <div style={{
      textAlign: 'center',
      padding: '32px 0'
    }} data-id="element-213">
        <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/hnodgoqduyba7n8dlqxg6c/d4d40573-a6d5-4127-bafb-e288840a0b5f/AISCO_WORKSPACE_MARCA_POSITIVO.svg" alt="Aisco Workspace" style={{
        height: '40px',
        display: 'inline-block'
      }} data-id="element-214" />
      </div>

      {/* Main content */}
      <div style={{
      backgroundColor: '#ffffff',
      padding: '40px 32px'
    }} data-id="element-215">
        <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '24px'
      }} data-id="element-216">
          <h1 style={{
          fontSize: '24px',
          fontWeight: '600',
          color: '#1f2937',
          margin: '0'
        }} data-id="element-217">
            New claim registered
          </h1>
          <span style={{
          fontSize: '13px',
          fontWeight: '600',
          color: '#2563eb',
          backgroundColor: '#eff6ff',
          padding: '4px 12px',
          borderRadius: '4px',
          border: '1px solid #bfdbfe'
        }} data-id="element-218">
            {2025240691}
          </span>
        </div>

        <p style={{
        fontSize: '16px',
        color: '#4b5563',
        lineHeight: '1.6',
        marginBottom: '8px'
      }} data-id="element-219">
          Hello <strong data-id="element-220">CANAGRO EXPORTS INC.</strong>,
        </p>

        <p style={{
        fontSize: '16px',
        color: '#4b5563',
        lineHeight: '1.6',
        marginBottom: '32px'
      }} data-id="element-221">
          A new claim has been registered in Aisco Workspace and is now
          available for tracking online.
        </p>

        {/* Claim Details */}
        <div style={{
        backgroundColor: '#f9fafb',
        padding: '20px',
        borderRadius: '8px',
        border: '1px solid #e5e7eb',
        marginBottom: '24px'
      }} data-id="element-222">
          <h3 style={{
          fontSize: '14px',
          fontWeight: '600',
          color: '#6b7280',
          marginTop: '0',
          marginBottom: '16px',
          textTransform: 'uppercase',
          letterSpacing: '0.5px'
        }} data-id="element-223">
            Claim Information
          </h3>
          <div style={{
          display: 'grid',
          gap: '12px'
        }} data-id="element-224">
            <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            fontSize: '14px',
            lineHeight: '1.6'
          }} data-id="element-225">
              <span style={{
              color: '#6b7280'
            }} data-id="element-226">
                Report Date:
              </span>
              <span style={{
              color: '#1f2937',
              fontWeight: '500'
            }} data-id="element-227">
                January 15, 2025
              </span>
            </div>
            <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            fontSize: '14px',
            lineHeight: '1.6'
          }} data-id="element-228">
              <span style={{
              color: '#6b7280'
            }} data-id="element-229">
                Business Unit:
              </span>
              <span style={{
              color: '#1f2937',
              fontWeight: '500'
            }} data-id="element-230">
                Aisco Europe
              </span>
            </div>
            <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            fontSize: '14px',
            lineHeight: '1.6'
          }} data-id="element-231">
              <span style={{
              color: '#6b7280'
            }} data-id="element-232">
                Claim Type:
              </span>
              <span style={{
              color: '#1f2937',
              fontWeight: '500'
            }} data-id="element-233">
                Technical Issue
              </span>
            </div>
            <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            fontSize: '14px',
            lineHeight: '1.6'
          }} data-id="element-234">
              <span style={{
              color: '#6b7280'
            }} data-id="element-235">
                Customer:
              </span>
              <span style={{
              color: '#1f2937',
              fontWeight: '500'
            }} data-id="element-236">
                Dimitri Yakolev
              </span>
            </div>
          </div>
        </div>

        {/* Machine Details */}
        <div style={{
        backgroundColor: '#f9fafb',
        padding: '20px',
        borderRadius: '8px',
        border: '1px solid #e5e7eb',
        marginBottom: '24px'
      }} data-id="element-237">
          <h3 style={{
          fontSize: '14px',
          fontWeight: '600',
          color: '#6b7280',
          marginTop: '0',
          marginBottom: '16px',
          textTransform: 'uppercase',
          letterSpacing: '0.5px'
        }} data-id="element-238">
            Machine Details
          </h3>
          <div style={{
          display: 'grid',
          gap: '12px'
        }} data-id="element-239">
            <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            fontSize: '14px',
            lineHeight: '1.6'
          }} data-id="element-240">
              <span style={{
              color: '#6b7280'
            }} data-id="element-241">
                Serial Number:
              </span>
              <span style={{
              color: '#1f2937',
              fontWeight: '500'
            }} data-id="element-242">
                002457898987
              </span>
            </div>
            <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            fontSize: '14px',
            lineHeight: '1.6'
          }} data-id="element-243">
              <span style={{
              color: '#6b7280'
            }} data-id="element-244">
                Installation Date:
              </span>
              <span style={{
              color: '#1f2937',
              fontWeight: '500'
            }} data-id="element-245">
                May 17, 2025
              </span>
            </div>
          </div>
        </div>

        {/* Problem Description */}
        <div style={{
        backgroundColor: '#eff6ff',
        padding: '20px',
        borderRadius: '8px',
        borderLeft: '4px solid #2563eb',
        marginBottom: '32px'
      }} data-id="element-246">
          <h3 style={{
          fontSize: '14px',
          fontWeight: '600',
          color: '#1e40af',
          marginTop: '0',
          marginBottom: '12px',
          textTransform: 'uppercase',
          letterSpacing: '0.5px'
        }} data-id="element-247">
            Problem Description
          </h3>
          <p style={{
          margin: '0',
          color: '#1e40af',
          fontSize: '14px',
          lineHeight: '1.6'
        }} data-id="element-248">
            Fallo de tarjeta SIM en Icontrol pump por cantidad de dias de
            inactividad. pedimos que nos envien tarjetas SIM de repuesto (en lo
            posible de "Telefonica" ya que es la compania que mejor cobertura
            ofrece en la zona.
          </p>
        </div>

        {/* CTA Button */}
        <div style={{
        textAlign: 'center',
        margin: '32px 0'
      }} data-id="element-249">
          <a href="#" style={{
          display: 'inline-block',
          backgroundColor: '#2563eb',
          color: '#ffffff',
          padding: '14px 32px',
          borderRadius: '8px',
          textDecoration: 'none',
          fontSize: '16px',
          fontWeight: '600'
        }} data-id="element-250">
            Track claim online
          </a>
        </div>

        <p style={{
        fontSize: '14px',
        color: '#6b7280',
        lineHeight: '1.6',
        marginTop: '32px',
        marginBottom: '0',
        textAlign: 'center'
      }} data-id="element-251">
          You can track the status and updates of this claim at any time through
          Aisco Workspace.
        </p>
      </div>

      {/* Footer */}
      <div style={{
      backgroundColor: '#f9fafb',
      padding: '24px 32px',
      borderTop: '1px solid #e5e7eb',
      textAlign: 'center'
    }} data-id="element-252">
        <p style={{
        fontSize: '12px',
        color: '#6b7280',
        lineHeight: '1.5',
        margin: '0'
      }} data-id="element-253">
          Aisco Europe S.A.U • Calle Playa de Riazor 22, 28042
          <br data-id="element-254" />
          Madrid, Spain
        </p>
      </div>
    </div>;
}